/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react'

import { _object } from 'utils/interfaces'

import { Pagination } from 'components'
import { categoryService, mediaService } from 'services'
import { toast } from 'react-toastify'
import store from 'store'
import { DeleteIcon } from 'assets/svg'

const Categories = () => {
  const [loading, setLoading] = useState(false)
  const [results, setResults] = useState<_object>({})
  const [selectedFile, setSelectedFile] = useState<_object>({})
  const [isUploading, setIsUploading] = useState<string | null>(null)

  const [filters, setFilters] = useState<_object>({
    q: '',
    page: 1,
    per_page: 25,
    sort: 'created_at'
  })
  const getCategories = () => {
    setLoading(true)
    categoryService.getCategories({ per_page: 999 }).then((results: _object) => {
      setLoading(false)
      setResults(results)
    })
  }
  useEffect(() => {
    getCategories()
  }, [filters])

  const handleImageChange = (e: _object, id: string) => {
    const file = e.target.files ? e.target.files[0] : null
    if (file) {
      setSelectedFile({ file: file, id: id })
    }
  }
  useEffect(() => {
    if (!selectedFile.id) return
    setIsUploading(selectedFile.id)
    const uploadImage = async () => {
      const data = new FormData()
      if (selectedFile.id) {
        data.append('entity_id', selectedFile.id)
      }
      data.append('entity_type', 'category')
      data.append('key', 'category_image')
      data.append('files', selectedFile.file)
      const accessToken = store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || '')

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/media`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: accessToken ? accessToken : ''
        },
        body: data
      })

      const result = await response.json()
      if (result.error === false) {
        toast.success(result.message || 'Image uploaded successfully.', {
          autoClose: 3000
        })
        getCategories()
      } else if (result.error === true) {
        toast.error(result.message || 'Image not uploaded.', {
          autoClose: 3000
        })
      }
      setIsUploading(null)
    }

    uploadImage()
  }, [selectedFile])

  const deleteSlide = (id: string) => {

    if (window.confirm('Are you sure you want to delete this slide?')) {
      mediaService.deleteMediaData(id).then((results: _object) => {
        if (results?.error === false) {
          getCategories()
        }
      })
    }
  }

  return (
    <>
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-semibold">
          Category <small>Total records: {results?.pagination?.total_items}</small>
        </h1>
      </div>
      <div className="overflow-x-auto rounded-lg bg-white shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr className="text-left text-sm font-medium text-gray-900">
              <th className="px-4 py-3 font-semibold">#</th>
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Description</th>
              <th className="px-4 py-3 font-semibold">Image W-100px H-100px Aspect Ratio 1:1 </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-gray-100 text-sm">
            {loading === false ? (
              results?.items?.map((item: _object, i: number) => {
                return (
                  <>
                    <tr className="hover:bg-gray-50" key={i}>
                      <td className="px-4 py-3">{i + 1}</td>
                      <td className="px-4 py-3">{item?.name}</td>
                      <td className="px-4 py-3">{item?.description}</td>

                      <td className="px-4 py-3">
                        {item?.image ? (
                          <>
                            <div className="relative inline-block h-12 w-12">
                              <img
                                src={item?.image}
                                alt={item.title}
                                className="h-full w-full rounded object-cover"
                              />
                              <button
                                type="button"
                                onClick={() => deleteSlide(item.image_id)}
                                title="Delete Slide"
                                className="absolute top-0 right-0 rounded-full bg-white p-1 shadow-sm hover:bg-gray-100"
                              >
                                <DeleteIcon className="h-[16px] w-[16px] text-red-500" />
                              </button>
                            </div>
                          </>
                        ) : (
                          <label htmlFor={item.id}>
                            <div className="flex h-12 w-12 cursor-pointer items-center justify-center rounded-md border-2 border-dashed border-purple-900">
                              <input
                                type="file"
                                id={item.id}
                                accept=".png, .jpg, .jpeg"
                                onChange={(e: _object) => handleImageChange(e, item.id)}
                                className="hidden"
                              />
                              {isUploading === item.id ? (
                                <svg
                                  className="h-8 w-8 animate-spin text-purple-900"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                  ></path>
                                </svg>
                              ) : (
                                <>
                                  <span className="text-2xl font-bold text-purple-900">+</span>
                                </>
                              )}
                            </div>
                          </label>
                        )}
                      </td>
                    </tr>
                  </>
                )
              })
            ) : (
              <Skeleton />
            )}
            {results?.items?.length <= 0 && <p>No record found</p>}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {results?.pagination?.total_pages > 1 && (
        <Pagination
          pageCount={results?.pagination?.total_pages}
          current_page={results?.pagination?.current_page}
          onPageChange={(e: _object) => {
            setFilters({ ...filters, page: e.selected + 1 })
          }}
        />
      )}
    </>
  )
}

export default Categories

const Skeleton = () => {
  return (
    <tr className="animate-pulse">
      <td className="px-4 py-3">
        <div className="h-4 w-6 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-32 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-12 rounded bg-gray-300"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 w-8 rounded bg-gray-300"></div>
      </td>
    </tr>
  )
}
